import { apiClient } from "@/api/client";
import { captureEntityMutation } from "@/analytics/posthog";

export type TransactionImportError = {
  line_number: number | null;
  field: string | null;
  message: string;
};

export type TransactionImportPreview = {
  import_id: number;
  filename: string;
  status: "INVALID" | "READY" | "COMPLETED" | "FAILED";
  row_count: number;
  valid_row_count: number;
  error_count: number;
  created_count: number;
  duplicate_count: number;
  errors: TransactionImportError[];
};

export const previewTransactionImport = async (file: File): Promise<TransactionImportPreview> => {
  const data = new FormData();
  data.append("file", file);

  const response = await apiClient.post<TransactionImportPreview>("/imports/transactions/preview", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return response.data;
};

export const confirmTransactionImport = async (importId: number): Promise<TransactionImportPreview> => {
  try {
    const response = await apiClient.post<TransactionImportPreview>(`/imports/transactions/${importId}/confirm`);
    captureEntityMutation({ entity: "transaction", operation: "create", result: "success" });
    return response.data;
  } catch (error) {
    captureEntityMutation({ entity: "transaction", operation: "create", result: "failure", error });
    throw error;
  }
};
